export default __webpack_public_path__ + "static/media/visomotor-logo.0e1dfa9d.jpg";